import { create } from 'zustand';

export const useMobileRoutingStore = create((set) => ({
  /**
   * modal state
   * controls whether the modal is open
   */
  isOpen: false,

  /**
   * open a link or show the mobile modal
   */
  tryRouting: (action) => {
    return action();
  },

  closeModal: () => {
    return set({ isOpen: false });
  },

  openModal: () => {
    return set({ isOpen: true });
  },
}));

export const mobileRoutingStoreSelector = {
  tryRouting: (state) => state.tryRouting,
  openModal: (state) => state.openModal,
  closeModal: (state) => state.closeModal,
  isOpen: (state) => state.isOpen,
};
